



















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Anagrafica } from "../models/anagrafica.model";

@Component({})
export default class AnagraficaDetail extends Vue {
	@Prop() anagrafica!: Anagrafica;

	ordine: string = process.env.VUE_APP_ORDINE;

	get settore(): string {
		const s = [];
		if (this.anagrafica.settorea) s.push("Civile e Ambientale");
		if (this.anagrafica.settoreb) s.push("Industriale");
		if (this.anagrafica.settorec) s.push("Informazione");
		return s.join(" - ");
	}

	get indirizzoText() {
		const s = [];
		if (this.anagrafica.indirizzo) s.push(this.anagrafica.indirizzo);
		if (this.anagrafica.cap) s.push(this.anagrafica.cap);
		if (this.anagrafica.comune) s.push(this.anagrafica.comune);
		if (this.anagrafica.provincia && this.anagrafica.provincia != this.anagrafica.comune) s.push(this.anagrafica.provincia);
		return s.join(" ");
	}

	get indirizzoProfessionaleText() {
		const s = [];
		if (this.anagrafica.indirizzoattivita) s.push(this.anagrafica.indirizzoattivita);
		if (this.anagrafica.capattivita) s.push(this.anagrafica.capattivita);
		if (this.anagrafica.comuneattivita) s.push(this.anagrafica.comuneattivita);
		if (this.anagrafica.provinciaattivita && this.anagrafica.provinciaattivita != this.anagrafica.comuneattivita) s.push(this.anagrafica.provinciaattivita);
		return s.join(" ");
	}


	get indirizzoDomiclioText() {
		const s = [];
		if (this.anagrafica.indirizzodom) s.push(this.anagrafica.indirizzodom);
		if (this.anagrafica.capdom) s.push(this.anagrafica.capdom);
		if (this.anagrafica.comunedom) s.push(this.anagrafica.comunedom);
		if (this.anagrafica.provinciadom && this.anagrafica.provinciadom != this.anagrafica.comunedom) s.push(this.anagrafica.provinciadom);
		return s.join(" ");
	}
}
